import React from 'react';
import MicrosoftIcon from 'flow/components/icons/MicrosoftIcon';
import HubspotIcon from 'flow/components/icons/HubspotIcon';
import ZendeskIcon from 'flow/components/icons/ZendeskIcon';
import FreshdeskIcon from 'flow/components/icons/FreshdeskIcon';
import FreshserviceIcon from 'flow/components/icons/FreshserviceIcon';
import SalesforceIcon from 'flow/components/icons/SalesforceIcon';
import TelavoxIcon from 'flow/components/icons/TelavoxIcon';
import { getIntegrationHost } from 'flow/utils/is-integration';

export const CTI_HOST_DESCRIPTION = {
    HUBSPOT: 'HubSpot',
    ZENDESK: 'Zendesk',
    FRESHDESK: 'Freshdesk',
    FRESHSERVICE: 'Freshservice',
    SALESFORCE: 'Salesforce',
    MICROSOFT_DYNAMICS: 'Microsoft Dynamics 365',
    TELAVOX_PARTNER: 'Telavox Partner',
    DEFAULT: 'CTI Integration',
};

const defaultConfig = {
    description: CTI_HOST_DESCRIPTION.DEFAULT,
    allowMultipleInstancesOnOpen: false,
};

const createConfig = (overloads) => {
    return { ...defaultConfig, ...overloads };
};

const CTI_CONFIG = {
    [CTI_HOST_DESCRIPTION.HUBSPOT]: createConfig({
        description: CTI_HOST_DESCRIPTION.HUBSPOT,
        allowMultipleInstancesOnOpen: true,
    }),
    [CTI_HOST_DESCRIPTION.MICROSOFT_DYNAMICS]: createConfig({
        description: CTI_HOST_DESCRIPTION.MICROSOFT_DYNAMICS,
    }),
    [CTI_HOST_DESCRIPTION.ZENDESK]: createConfig({
        description: CTI_HOST_DESCRIPTION.ZENDESK,
    }),
    [CTI_HOST_DESCRIPTION.FRESHDESK]: createConfig({
        description: CTI_HOST_DESCRIPTION.FRESHDESK,
    }),
    [CTI_HOST_DESCRIPTION.FRESHSERVICE]: createConfig({
        description: CTI_HOST_DESCRIPTION.FRESHSERVICE,
    }),
    [CTI_HOST_DESCRIPTION.SALESFORCE]: createConfig({
        description: CTI_HOST_DESCRIPTION.SALESFORCE,
    }),
    [CTI_HOST_DESCRIPTION.TELAVOX_PARTNER]: createConfig({
        description: CTI_HOST_DESCRIPTION.TELAVOX_PARTNER,
    }),
};

const getConfigByDescription = (description) => {
    return CTI_CONFIG[description] ? CTI_CONFIG[description] : createConfig();
};

export const allowMultipleInstancesOnOpen = (hostSystemDescription) => {
    return getConfigByDescription(hostSystemDescription)
        .allowMultipleInstancesOnOpen;
};

export const getCtiHostIcon = (hostDescription) => {
    switch (hostDescription) {
        case CTI_HOST_DESCRIPTION.HUBSPOT:
            return <HubspotIcon />;
        case CTI_HOST_DESCRIPTION.ZENDESK:
            return <ZendeskIcon />;
        case CTI_HOST_DESCRIPTION.FRESHDESK:
            return <FreshdeskIcon />;
        case CTI_HOST_DESCRIPTION.FRESHSERVICE:
            return <FreshserviceIcon />;
        case CTI_HOST_DESCRIPTION.SALESFORCE:
            return <SalesforceIcon />;
        case CTI_HOST_DESCRIPTION.MICROSOFT_DYNAMICS:
            return <MicrosoftIcon size={12} />;
        case CTI_HOST_DESCRIPTION.TELAVOX_PARTNER:
            return <TelavoxIcon />;
        default:
            return null;
    }
};

export const getCtiHost = () => {
    const integrationHost = getIntegrationHost();
    return integrationHost === null
        ? CTI_HOST_DESCRIPTION.DEFAULT
        : integrationHost.toLowerCase();
};

export const getLocalStorageSettingsKey = () => {
    return `tvx:settings:cti:${getCtiHost()}`;
};
